<template>
  <div class="detail-card" v-if="Object.keys(courseInfoModule).length">
    <div class="detail-card__title">
<!--      <span class="detail-card__tag presale" v-if="Number(courseDetail.isPreSale) === 1"-->
<!--        >预售</span-->
<!--      >-->
      <span class="detail-card__tag subject">
        {{ courseInfoModule.subjects[0].name }}
      </span>
      <span class="detail-card__title__name" v-html="xss(courseInfoModule.courseName)"></span>
    </div>
    <div class="detail-card__info">
      <p class="detail-card__info__item" v-if="Number(courseInfoModule.category) !== 1">
        {{ courseInfoModule.schooltimeName }}
      </p>
      <!-- <p class="detail-card__info__item" v-if="Number(courseDetail.category) !== 1">课程内容：{{courseDetail.syllabusNum}}讲视频课程</p> -->
      <p
        class="detail-card__info__item"
        v-if="
          Number(courseInfoModule.category) !== 1 &&
          courseInfoModule.difficulty &&
            courseInfoModule.difficulty.alias &&
            !/\D/.test(courseInfoModule.difficulty.alias)
        "
      >
        难度：<i
          v-for="index of Number(courseInfoModule.difficulty.alias)"
          :key="index"
          class="iconfont2 icon-star-fill"
        ></i>
      </p>
      <p
        class="detail-card__info__item"
        v-if="Number(courseInfoModule.category) !== 1"
        v-html="courseInfoModule.secondTitle"
      ></p>
      <p
        class="detail-card__info__item"
        v-if="Number(courseInfoModule.category) === 1 && courseInfoModule.buyNumDesc"
      >
        {{ courseInfoModule.buyNumDesc }}
      </p>
      <!-- <p class="detail-card__info__item">{{courseDetail.saletimes.validDay}}</p> -->
    </div>
    <div class="detail-card__teacher">
      <!--主讲老师-->
      <teacher
        v-if="teacherModule.chinaTeacher && teacherModule.chinaTeacher.length > 0"
        :data="teacherModule.chinaTeacher"
        :title="teacherModule.chinaTeacher[0].title"
      ></teacher>
      <!--外交老师-->
      <teacher
        v-if="teacherModule.foreignTeacher && teacherModule.foreignTeacher.length > 0"
        :data="teacherModule.foreignTeacher"
      />
      <!--助教老师-->
      <template v-if="teacherModule.counsolerInfo && teacherModule.counsolerInfo.length > 0">
        <teacher
          :excTeacherCourse="teacherModule.excTeacherCourse"
          :data="teacherModule.counsolerInfo"
        />
      </template>
    </div>
    <free-video
      v-if="freeAuditionModule && freeAuditionModule.length > 0"
      :data="freeAuditionModule"
    ></free-video>
  </div>
</template>

<script>
import methods from '@/views/CourseDetail/mixins/methods'
import FreeVideo from './FreeVideo'
import Teacher from './Teacher'
export default {
  props: {
    courseInfoModule: {
      type: [Array, Object],
      default: () => []
    },
    teacherModule: {
      type: [Array, Object],
      default: () => []
    },
    freeAuditionModule: {
      type: [Array, Object],
      default: () => []
    }
  },
  mixins: [methods],
  data() {
    return {}
  },
  components: {
    FreeVideo,
    Teacher
  }
}
</script>

<style scoped lang="scss">
@import 'src/scss/entry';
@import 'src/views/CourseDetail/index.scss';
@import 'src/views/CourseDetail/common.scss';
@include b(detail-card) {
  padding: 20px;
  background: #ffffff;
  @include e(title) {
    user-select: text;
    line-height: 28px;
    @include e(name) {
      font-size: 20px;
      font-family: MicrosoftYaHei;
      color: rgba(51, 51, 51, 1);
      line-height: 28px;
    }
  }
  @include e(info) {
    margin-top: 6px;
    user-select: text;
    @include e(item) {
      font-size: 14px;
      line-height: 26px;
      color: #666666;
      & > i {
        margin-left: 8px;
      }
    }
  }
  @include e(teacher) {
    margin-top: 20px;
    margin-left: -20px;
    margin-right: -20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    @include e(item) {
      position: relative;
      margin: 16px 20px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }
  @include e(tag) {
    box-sizing: border-box;
    display: inline-block;
    font-size: 14px;
    margin: 4px 4px;
    height: 20px;
    line-height: 20px;
    padding: 0 4px;
    min-width: 20px;
    text-align: center;
    border-radius: 2px;
    background-color: #DCAF80;
    vertical-align: top;
    &.presale {
      background-color: #f07737;
      color: #fff;
      border: 1px solid #f07737;
    }
    &.subject {
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/NewCourseDetail/modules/DetailCard.vue